// Hand-written extension of workflowApi (NOT auto-generated — see web-app/CLAUDE.md's codegen
// rule for why the *Api.ts files themselves are never hand-edited). RTK Query's supported way to
// add an endpoint to an existing createApi() instance from application code is injectEndpoints —
// this covers the one tenant-facing route (/api/v1/workflows/governance-actions) that has no
// platform_workflows OpenAPI-codegen counterpart yet.
import { workflowApi } from './workflowApi';

/** What a business module can be bound as — the guardrail each binding picker filters on.
 *  See api-service app/db/seed/sc/business_modules_seed.py for the full contract.
 *  - `action`  a Python callable is registered for this module_code (verified server-side against
 *              the live registry, so this value is trustworthy, not a declaration)
 *  - `display` a display card exists in WorkflowCard.tsx's BUSINESS_MODULE_DISPLAY_COMPONENTS
 *  - `capture` a pre-transition capture form exists in BUSINESS_CAPTURE_COMPONENTS
 */
export type ModuleCapability = 'action' | 'display' | 'capture';

export interface GovernanceActionOption {
  /** The module_code. Named action_key for backward compatibility with existing gate/hook configs. */
  action_key: string;
  /** Admin-facing label. Show this in pickers — action_key is an identifier, not copy. */
  name: string;
  description: string;
  /** Domain grouping for <optgroup> headings. Vocabulary is config-driven
   *  (workflow_engine.business_module_categories) — never hardcode a list of these. */
  category: string;
  entity_type: string;
  /** Effective capabilities: `action` reflects the LIVE registry, not the catalogue's claim. */
  capabilities: ModuleCapability[];
  /** What the catalogue itself claims — differs from `capabilities` only when drifted. */
  declared_capabilities: ModuleCapability[];
  /** Human-readable descriptions of catalogue-vs-registry disagreements. Empty when consistent. */
  capability_drift: string[];
  /** The module's input contract, derived from what its callable reads out of `input_values`. */
  module_inputs: ModuleInput[];
  /** False by default — a retried non-idempotent action repeats its side effect. */
  is_idempotent: boolean;
  /** False when a REQUIRED input is runtime-collected: there is no admin-suppliable value, so an
   *  automation hook could never satisfy it and the backend refuses such a binding. */
  hook_bindable: boolean;
}

/** One declared input of a business module. See api-service business_modules_seed.py `_input`. */
export interface ModuleInput {
  name: string;
  /** `list` is multi-valued; `allowed_values` then constrains each ELEMENT rather than the
   *  whole value, and the UI renders it as a set of checkboxes. */
  type: 'str' | 'int' | 'float' | 'bool' | 'datetime' | 'enum' | 'list';
  required: boolean;
  /** Collected from the USER at capture time — cannot be a fixed admin-typed value. */
  runtime: boolean;
  /** Rendered as placeholder text so a blank field visibly shows the module's fallback. */
  default: unknown;
  description: string;
  allowed_values: unknown[];
}

/** Single place that answers "may this module be bound as X?" so the three pickers can't drift
 *  apart in how they decide it. */
export const hasCapability = (m: GovernanceActionOption, cap: ModuleCapability): boolean =>
  (m.capabilities ?? []).includes(cap);

export interface GovernanceActionsResponse {
  success: boolean;
  message_code: number;
  data: GovernanceActionOption[];
}

export interface GovernanceOptionPreviewItem {
  value: string;
  label: string;
}

export interface GovernanceOptionsPreviewResponse {
  success: boolean;
  message_code: number;
  data: { available: boolean; options: GovernanceOptionPreviewItem[] };
}

export const workflowGovernanceApi = workflowApi.injectEndpoints({
  endpoints: (builder) => ({
    listGovernanceActions: builder.query<GovernanceActionsResponse, void>({
      query: () => '/api/v1/workflows/governance-actions',
    }),
    previewGovernanceOptions: builder.query<GovernanceOptionsPreviewResponse, { role: string }>({
      query: ({ role }) => `/api/v1/workflows/governance-options/preview?role=${encodeURIComponent(role)}`,
    }),
  }),
});

export const { useListGovernanceActionsQuery, usePreviewGovernanceOptionsQuery } = workflowGovernanceApi;
